import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import PublicInfoPage from "../components/PublicInfo/PublicInfoPage";

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Política de Privacidad | Alohar</title>
        <meta
          name="description"
          content="Conocé qué datos puede recopilar Alohar, cómo se usan, cómo funcionan las cookies y qué canales tenés para ejercer tus derechos de privacidad."
        />
        <link rel="canonical" href="https://alohar.me/politica-de-privacidad" />
      </Helmet>
      <Navbar addSearch={false} hideAlohadorButtons={true} hideSearchButtons={true} />
      <PublicInfoPage
        eyebrow="Privacidad y datos"
        title="Política de privacidad de Alohar"
        intro="Esta página resume de forma clara cómo Alohar trata la información necesaria para operar reservas, cuentas de usuario, contacto y soporte. La usamos para explicar qué datos podemos solicitar, por qué los necesitamos y qué opciones tenés para consultar o actualizar tu información."
        lastUpdated="15 de marzo de 2026"
        highlights={[
          {
            title: "Datos de cuenta y reserva",
            description:
              "Podemos procesar nombre, email, teléfono, datos de perfil, datos de reserva y la información necesaria para coordinar estadías o pagos dentro de la plataforma.",
          },
          {
            title: "Cookies y sesión",
            description:
              "Usamos tecnologías de sesión, cookies técnicas y mediciones básicas para mantener la cuenta iniciada, mejorar la navegación y entender el uso general del sitio.",
          },
          {
            title: "Derechos y contacto",
            description:
              "Si necesitás consultar, corregir o reportar un tema vinculado a tus datos, podés escribir a los canales públicos de Alohar que se indican más abajo.",
          },
        ]}
        sections={[
          {
            title: "Qué información puede recopilar Alohar",
            paragraphs: [
              "Cuando creás una cuenta o hacés una reserva, Alohar puede recibir información de identificación y contacto como nombre, apellido, correo electrónico, teléfono, fecha de nacimiento y datos básicos del perfil. Si publicás un alojamiento, también podemos almacenar información del anuncio, disponibilidad, reglas, ubicación y medios de cobro necesarios para operar la publicación.",
              "Si te comunicás con soporte o con otra persona dentro de la plataforma, podemos conservar mensajes, solicitudes y datos relacionados con la reserva para dar seguimiento, prevenir fraude y resolver incidencias operativas.",
            ],
            bullets: [
              "Datos de cuenta y autenticación para ingresar o recuperar acceso.",
              "Información de contacto y perfil para reservas, soporte o publicaciones.",
              "Datos vinculados a cobros y pagos procesados por proveedores habilitados.",
              "Información sobre reservas, estadías, cancelaciones y comunicaciones asociadas.",
            ],
          },
          {
            title: "Cookies, sesiones y analítica básica",
            paragraphs: [
              "Alohar puede usar cookies y herramientas técnicas similares para recordar sesiones, validar el inicio de cuenta, mantener preferencias de navegación y detectar errores o actividad irregular. También podemos emplear mediciones agregadas para entender cómo se usan las páginas públicas y mejorar la experiencia de búsqueda o reserva.",
              "Estas herramientas no reemplazan la lectura de los ajustes del navegador o del dispositivo. Si desactivás algunas cookies técnicas, ciertas funciones del sitio podrían dejar de funcionar correctamente.",
            ],
          },
          {
            title: "Cómo utilizamos la información",
            bullets: [
              "Operar cuentas, reservas, pagos y comunicaciones dentro de la plataforma.",
              "Brindar atención al usuario, seguimiento de incidencias y soporte comercial.",
              "Prevenir fraude, validar actividad sospechosa y resguardar la seguridad operativa.",
              "Mejorar el funcionamiento del sitio, la experiencia de búsqueda y la claridad de los anuncios.",
            ],
          },
          {
            title: "Con quién puede compartirse",
            paragraphs: [
              "Alohar puede compartir información necesaria con proveedores de pago, servicios técnicos o partes involucradas en una reserva cuando resulte indispensable para ejecutar la operación, verificar identidad, gestionar una estadía o cumplir obligaciones legales. No publicamos información privada fuera de esos fines operativos y de soporte.",
            ],
          },
          {
            title: "Tus derechos y cómo contactarnos",
            paragraphs: [
              "Si querés consultar qué datos tenés cargados, solicitar una corrección o informar un problema de privacidad, podés escribir a hola@alohar.me. Si el asunto está relacionado con seguridad de cuenta, acceso no autorizado o riesgo digital, también podés comunicarte por denuncias@alohar.me.",
              "Vamos a responder por los canales habituales de atención y, cuando corresponda, podremos pedir información adicional para verificar la titularidad de la cuenta antes de gestionar el pedido.",
            ],
          },
        ]}
        relatedLinks={[
          {
            to: "/terminos",
            label: "Términos y condiciones",
            description: "Revisá el marco general de uso de la plataforma, reservas y responsabilidades.",
          },
          {
            to: "/ayuda",
            label: "Centro de ayuda",
            description: "Encontrá respuestas sobre reservas, pagos, cancelaciones y uso de Alohar.",
          },
          {
            to: "/contacto",
            label: "Contacto",
            description: "Canales públicos para soporte, incidencias y consultas generales.",
          },
          {
            to: "/quienes-somos",
            label: "Quiénes somos",
            description: "Conocé qué hace Alohar y qué tipo de experiencia busca ofrecer.",
          },
        ]}
      />
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;